import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('@/views/login')
    },
    {
      path: '/main',
      name: 'main',
      redirect: '/home/home',
      component: () => import('@/views/main'),
      children: [
        { path: '/home/home', component: () => import('@/views/main/home/home') },
        // 行程预定
        { path: 'travelBooking',
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: () => import('@/views/main/TravelBooking'),
          children: [
            {
              // 国内机票
              path: '/dom/book',
              component: () => import('@/views/main/dom/book/domBook')
            },
            {
              // 国内机票订单确认
              path: '/dom/book/domOrderSubmit',
              component: () => import('@/views/main/dom/book/domOrderSubmit')
            },
            {
              // 国际机票
              path: '/inter/book',
              // @/views/main/inter/programme/interProgrammeBook
              component: () => import('@/views/main/inter/book/interBook')
            },
            {
              // 国际机票订单确认
              path: '/inter/book/interOrderSubmit',
              component: () => import('@/views/main/inter/book/interOrderSubmit')
            },
            {
              // 火车票
              path: '/train/book',
              component: () => import('@/views/main/train/book/trainBook')
            },
            {
              // 火车票订单确认
              path: '/train/book/trainOrderSubmit',
              component: () => import('@/views/main/train/book/trainOrderSubmit')
            },
            {
              // 酒店
              path: '/hotel/book',
              component: () => import('@/views/main/hotel/book/hotelBook')
            },
            {
              // 酒店详情
              path: '/hotel/book/detail',
              component: () => import('@/views/main/hotel/book/hotelDetailBook')
            },
            {
              // 酒店订单确认
              path: '/hotel/book/hotelOrderSubmit',
              component: () => import('@/views/main/hotel/book/hotelOrderSubmit')
            }
          ]
        },
        // 我的申请
        { path: '/myApply',
          component: () => import('@/views/main/myApply/myApplyIndex.vue'),
          redirect: '/myApply/tripApply/page',
          children: [
            {
              path: '/myApply/tripApply/page', // 出差申请
              component: () => import('@/views/main/myApply/tripApply/tripPage.vue')
            }
          ]
        },
        {
          // 出差申请详情
          path: '/myApply/tripApply/detail/:showTripApplyType/:tripNo',
          component: () => import('@/views/main/myApply/tripApply/tripInfo.vue')
        },
        // 我的审批
        { path: '/myApproval',
          component: () => import('@/views/main/myApproval'),
          children: [
            {
              // 出差审批
              path: '/myApproval/tripApproval',
              component: () => import('@/views/main/myApproval/tripApproval/tripApprovalPage')
            },
            {
              // 国内机票票审批
              path: '/myApproval/domPage/:queryType',
              component: () => import('@/views/main/dom/domPage')
            },
            {
              // 国际机票票审批
              path: '/myApproval/interPage/:queryType',
              component: () => import('@/views/main/inter/interPage')
            },
            {
              // 火车票审批
              path: '/myApproval/trainPage/:queryType',
              component: () => import('@/views/main/train/trainPage')
            },
            {
              // 酒店审批
              path: '/myApproval/hotelPage/:queryType',
              component: () => import('@/views/main/hotel/hotelPage')
            }
          ]
        },
        {
          // 出差审批详情 --- 待审批
          path: '/myApproval/tripApproval/detail/:showTripApplyType/:tripNo',
          component: () => import('@/views/main/myApply/tripApply/tripInfo.vue')
        },
        {
          // 国内机票审批详情
          path: '/myApproval/domOrderApprove/detail/:showDomOrderType/:domOrderNo',
          component: () => import('@/views/main/dom/order/domOrderInfo')
        },
        {
          // 国内机票退票审批详情
          path: '/myApproval/domRefundOrder/detail/:showRefundDomOrderType/:domRefundOrderNo',
          component: () => import('@/views/main/dom/refund/domRefundOrderInfo')
        },
        {
          // 国内机票改签审批详情
          path: '/myApproval/domChangeOrder/detail/:showRefundDomOrderType/:domChangeOrderNo',
          component: () => import('@/views/main/dom/change/domChangeOrderInfo')
        },
        {
          // 国际机票审批详情
          path: '/myApproval/interOrderApprove/detail/:showInterOrderType/:InterOrderNo',
          component: () => import('@/views/main/inter/order/interOrderInfo')
        },
        {
          // 火车票审批详情
          path: '/myApproval/trainOrderInfo/detail/:showTrainOrderType/:trainOrderNo',
          component: () => import('@/views/main/train/order/trainOrderInfo')
        },
        {
          // 火车票退票审批详情
          path: '/myApproval/trainRefundOrder/detail/:showTrainRefundOrderType/:trainRefundOrderNo',
          component: () => import('@/views/main/train/refund/trainRefundOrderInfo')
        },
        {
          // 火车票改签审批详情
          path: '/myApproval/trainChangeOrder/detail/:showTrainChangeOrderType/:trainChangeOrderNo',
          component: () => import('@/views/main/train/change/trainChangeOrderInfo')
        },
        {
          // 酒店审批详情
          path: '/myApproval/hotelOrder/detail/:showHotelOrderType/:hotelOrderNo',
          component: () => import('@/views/main/hotel/order/hotelOrderInfo')
        },
        {
          // 酒店退房审批详情
          path: '/myApproval/hotelRefundOrder/detail/:showHotelRefundOrderType/:hotelRefundOrderNo',
          component: () => import('@/views/main/hotel/refund/hotelRefundOrderInfo')
        },
        // 我的订单
        { path: '/myOrder',
          component: () => import('@/views/main/myOrder'),
          redirect: '/myOrder/domPage/1',
          children: [
            {
              // 国内机票
              path: '/myOrder/domPage/:queryType',
              component: () => import('@/views/main/dom/domPage')
            },
            {
              // 酒店
              path: '/myOrder/hotelPage/:queryType',
              component: () => import('@/views/main/hotel/hotelPage')
            },
            {
              // 火车票
              path: '/myOrder/trainPage/:queryType',
              component: () => import('@/views/main/train/trainPage')
            },
            {
              // 国际机票
              path: '/myOrder/interPage/:queryType',
              component: () => import('@/views/main/inter/interPage')
            }
          //  interOrderDetail.vue
          ]
        },
        {
          // 国内机票详情
          path: '/myOrder/domOrderInfo/detail/:showDomOrderType/:domOrderNo',
          component: () => import('@/views/main/dom/order/domOrderInfo')
        },
        {
          // 国内机票提交退票
          path: '/myOrder/submit/domRefundOrder',
          component: () => import('@/views/main/dom/refund/domRefundOrderSubmit')
        },
        {
          // 国内机票退票详情
          path: '/myOrder/domRefundOrder/detail/:showDomRefundOrderType/:domRefundOrderNo',
          component: () => import('@/views/main/dom/refund/domRefundOrderInfo')
        },
        {
          // 国内机票提交改签
          path: '/myOrder/submit/domChangeOrderSubmit',
          component: () => import('@/views/main/dom/change/domChangeOrderSubmit')
        },
        {
          // 国内机票改签详情
          path: '/myOrder/domChangeOrder/detail/:showDomChangeOrderType/:domChangeOrderNo',
          component: () => import('@/views/main/dom/change/domChangeOrderInfo')
        },
        {
          // 火车票详情
          path: '/myOrder/trainOrderInfo/detail/:showTrainOrderType/:trainOrderNo',
          component: () => import('@/views/main/train/order/trainOrderInfo')
        },
        {
          // 火车票退票提交页
          path: '/myOrder/submit/trainRefundOrderSubmit',
          component: () => import('@/views/main/train/refund/trainRefundOrderSubmit')
        },
        {
          // 火车票退票详情
          path: '/myOrder/trainRefundOrderInfo/detail/:showTrainRefundOrderType/:trainRefundOrderNo',
          component: () => import('@/views/main/train/refund/trainRefundOrderInfo')
        },
        {
          // 火车票改签提交页
          path: '/myOrder/submit/trainChangeOrderSubmit',
          component: () => import('@/views/main/train/change/trainChangeOrderSubmit')
        },
        {
          // 火车票改签详情
          path: '/myOrder/trainChangeOrderInfo/detail/:showTrainChangeOrderType/:trainChangeOrderNo',
          component: () => import('@/views/main/train/change/trainChangeOrderInfo')
        },
        {
          // 酒店订单详情
          path: '/myOrder/hotelOrderInfo/detail/:showHotelOrderType/:hotelOrderNo',
          component: () => import('@/views/main/hotel/order/hotelOrderInfo')
        },
        {
          // 酒店退房
          path: '/myOrder/submit/hotelRefundOrderSubmit',
          component: () => import('@/views/main/hotel/refund/hotelRefundOrderSubmit')
        },
        {
          // 酒店退房详情
          path: '/myOrder/hotelRefundOrder/detail/:showHotelRefundOrderType/:hotelRefundOrderNo',
          component: () => import('@/views/main/hotel/refund/hotelRefundOrderInfo')
        },
        {
          // 国际机票详情
          path: '/myOrder/interOrder/interDetail/:showInterOrderType/:InterOrderNo',
          component: () => import('@/views/main/inter/order/interOrderInfo')
        },
        // 我的行程
        {
          path: '/myJourney',
          component: () => import('@/views/main/myJourney/myJourney'),
          redirect: '/myJourney/myTrip',
          children: [
            {
              // 我的行程
              path: '/myJourney/myTrip',
              component: () => import('@/views/main/myJourney/myTrip/myTrip')
            },
            {
              // 历史行程
              path: '/myJourney/historyTrip',
              component: () => import('@/views/main/myJourney/myTrip/myTrip')
            }
          ]
        },
        // 个人中心
        { path: '/userName',
          component: () => import('@/views/main/userName'),
          redirect: '/userName/basics',
          children: [
            {
              // 基本资料
              path: '/userName/basics',
              component: () => import('@/views/main/userName/basics')
            },
            {
              // 证件信息
              path: '/userName/IDInfo',
              component: () => import('@/views/main/userName/IDInfo')
            },
            {
              // 我的秘书
              path: '/userName/mySecretary',
              component: () => import('@/views/main/userName/mySecretary')
            },
            {
              // 账号安全
              path: '/userName/accountSafety',
              component: () => import('@/views/main/userName/accountSafety')
            },
            {
              // 外部客户
              path: '/userName/outCustomer',
              component: () => import('@/views/main/userName/outCustomer')
            },
            {
              // 家属资料
              path: '/userName/familyInfo',
              component: () => import('@/views/main/userName/familyInfo')
            },
            {
              // 代审设置
              path: '/userName/agentApprover',
              component: () => import('@/views/main/userName/agentApprover/agentApproverList')
            }
          ]
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js